function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a705fc42-7a31-4e1f-ac28-df40fcf67768",
  d: "M116.81,85.7H93.59a1.48,1.48,0,0,1-1.48-1.48V60.89H81.63V84.22a1.48,1.48,0,0,1-1.48,1.48H56.93a1.47,1.47,0,0,1-1.47-1.48V40.38H45.11a1.47,1.47,0,0,1-1-2.6L57,26.82V10.49A1.48,1.48,0,0,1,58.52,9h9.32a1.47,1.47,0,0,1,1.48,1.47v5.9l16.6-14.1a1.47,1.47,0,0,1,1.91,0L129.6,37.78a1.49,1.49,0,0,1,.43,1.64,1.47,1.47,0,0,1-1.39,1H118.29V84.22A1.48,1.48,0,0,1,116.81,85.7Zm-21.74-3h20.26V38.91a1.48,1.48,0,0,1,1.48-1.48h7.81L86.87,5.35,68.8,20.71a1.48,1.48,0,0,1-2.43-1.13V12H60V27.5a1.48,1.48,0,0,1-.52,1.13l-10.35,8.8h7.8a1.48,1.48,0,0,1,1.48,1.48V82.74H78.68V59.42a1.47,1.47,0,0,1,1.47-1.48H93.59a1.48,1.48,0,0,1,1.48,1.48Z",
  transform: "translate(-43.63 -1.93)"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0d380f9-3871-4da4-bf95-48aee924bb9b",
    "data-name": "home",
    viewBox: "0 0 86.49 83.77",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.be59ae18.svg";
export { ForwardRef as ReactComponent };